import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'; // Import these

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 1;

  const navigate = useNavigate(); // Initialize navigate hook
  const [searchParams, setSearchParams] = useSearchParams(); // Initialize searchParams hook

  // Get initial page from URL, or default to 1
  // This ensures that if you load the URL with ?page=X, it starts on X
  const initialPage = parseInt(searchParams.get('page') || '1', 10);
  const [currentPage, setCurrentPage] = useState(initialPage);

  useEffect(() => {
    // This effect runs whenever currentPage changes (including initial load)
    // It updates the URL's query parameter.
    setSearchParams({ page: currentPage.toString() });

    async function fetchData() {
      try {
        // Construct the API URL with pagination, order, and orderby parameters
        const apiUrl = `https://ocdnewyork.org/wp/wp-json/wp/v2/posts?tags=11&per_page=${postsPerPage}&page=${currentPage}&order=desc&orderby=date`;
        const response = await fetch(apiUrl);

        // Get total pages from 'X-WP-TotalPages' header
        const totalPagesHeader = response.headers.get('X-WP-TotalPages');
        if (totalPagesHeader) {
          setTotalPages(parseInt(totalPagesHeader, 10));
        }

        const data = await response.json();
        setPosts(data);
      } catch (error) {
        console.error("Error fetching posts:", error);
        // Optionally, reset posts or show an error state
        setPosts([]);
      }
    }

    fetchData();
  }, [currentPage, setSearchParams]); // Add setSearchParams to dependencies

  // Event handlers for pagination
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Close button logic (consider managing this state within React for better practice)
  useEffect(() => {
    const toggleButtons = document.querySelectorAll('.close');
    const hiddenContent = document.querySelector('.overlay');

    const handleCloseClick = () => {
      if (hiddenContent) { // Check if element exists before manipulating
        hiddenContent.classList.remove('show');
      }
    };

    toggleButtons.forEach(button => {
      button.addEventListener('click', handleCloseClick);
    });

    // Cleanup event listeners when component unmounts
    return () => {
      toggleButtons.forEach(button => {
        button.removeEventListener('click', handleCloseClick);
      });
    };
  }, []); // Empty dependency array means this runs once on mount


  return (
    <div className='blog'>
      <div className="coming-soon-overlay">
        <div className="coming-soon-content">Coming Soon</div>
      </div>
      {posts.length > 0 ? (
        posts.map((post) => (
          <div className='inner' key={post.id} dangerouslySetInnerHTML={{ __html: post.content.rendered }}></div>
        ))
      ) : (
        <p>No posts found.</p>
      )}

      <div className="pagination-controls">
        <button onClick={handlePrevPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span> Page {currentPage} of {totalPages} </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
}

export default Blog;